var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRomania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 38,
    viewBox: "0 0 51 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5557_42394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9139 0.773438H5.43769C2.80776 0.773438 0.675781 2.98217 0.675781 5.70677V32.8401C0.675781 35.5647 2.80776 37.7734 5.43769 37.7734H45.9139C48.5438 37.7734 50.6758 35.5647 50.6758 32.8401V5.70677C50.6758 2.98217 48.5438 0.773438 45.9139 0.773438Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0088 0.773438H50.6755V37.7734H34.0088V0.773438Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675781 0.773438H17.3424V37.7734H0.675781V0.773438Z",
    fill: "#022A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5557_42394"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.675781,
    y: 0.773438,
    width: 50,
    height: 37,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomania);
export default __webpack_public_path__ + "static/media/Romania.33a3977bd814352cdf365d89e18150c1.svg";
export { ForwardRef as ReactComponent };